export const environmentSecret = { apiMapKey: 'uNVlI5eA31298h3i61yu', };
